import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { NgxSpinnerService } from "ngx-spinner";
//import { filter } from 'rxjs/operators';
export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}
/** Constants used to fill up our data base. */
const COLORS: string[] = [
  'maroon', 'red', 'orange', 'yellow', 'olive', 'green', 'purple', 'fuchsia', 'lime', 'teal',
  'aqua', 'blue', 'navy', 'black', 'gray'
];
const NAMES: string[] = [
  'Maia', 'Asher', 'Olivia', 'Atticus', 'Amelia', 'Jack', 'Charlotte', 'Theodore', 'Isla', 'Oliver',
  'Isabella', 'Jasper', 'Cora', 'Levi', 'Violet', 'Arthur', 'Mia', 'Thomas', 'Elizabeth'
];
// @Component({
//   selector: 'ngbd-modal-content',
//   template: `
//   <div class="modal-body">
//   <div class="holdPopup text-center">
//       <button type="button" class="close" aria-label="Close" >
//           <span aria-hidden="true">&times;</span>
//         </button>
//         <div>
//           <h6>Activate content capsule</h6>
//           <p class="size18">Are you sure you want to activate this content capsule?</p>
//           <a href="javascript:void(0);"  class="backPage ml-2 mr-2">No, cancel</a>
//           <a href="javascript:void(0);" class="btn btn-primary btn-sm">Yes, Activate</a>
//       </div>
//   </div>
// </div>
//   `
//   // (click)="modalService.dismiss('Cross click')"
// })
@Component({
  selector: 'app-authoring-list',
  templateUrl: './authoring-list.component.html',
  styleUrls: ['./authoring-list.component.scss']
})
export class AuthoringListComponent implements OnInit {
  name: any;
  adminData: any; content_capsule_id = ''; contentData: any = ''; content_capsule_ids: any = '';
  submitted = false; contentDetailsData: any; contentAuthForm: any;
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  searchText = ""; capsules_status = "2"; is_active = "1"; order_by = "created_dttm"; order = "DESC";
  data = {}; contentAuthData: any; capsule_name: any; media_type = ''; tabIndex: number = 0;tabName:any='';
  closeResult: any = '';

  constructor(public modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService) { 
      if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
        this.router.navigateByUrl('/admin-login');
      }
    }

  // open(content: any,content_capsule_id:any,is_active:"1") {
  //   this.contentData = content;
  //   this.content_capsule_ids = content_capsule_id;
  //   this.modalService.open(content, { centered: true, size: 'sm' });
  // }

  open(content: any, content_capsule_id: any,tab_name:any) {
    this.tabName = tab_name;
    this.content_capsule_ids = content_capsule_id;
    this.modalService.open(content, { size: 'sm',centered: true  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    //this.succesDelAssessment = false;
    //.activeDleMod = true;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  ngOnInit(): void {
    this.spinner.show();
    this.is_active = '1';
    this.route.queryParams.subscribe(queryParams => {
      this.tabIndex = queryParams['tab'];
      if(this.tabIndex ==2){
        this.capsules_status = '1';
      }
      if(this.tabIndex == 1){
        this.is_active = '0';
      }
    })
    this.getContentAuthList(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order); //draft
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');

  }
  /************ convert image url in base64  *****/
  toDataURL(src: any, callback: any) {
    let xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
      let fileReader = new FileReader();
      fileReader.onloadend = function () {
        callback(fileReader.result);
      }
      fileReader.readAsDataURL(xhttp.response);
    }
    xhttp.responseType = 'blob';
    xhttp.open('GET', src, true);
    xhttp.send();
  }

  onSelectChange(event: any) {
    if (event.index == 1) { //deactive
      this.is_active = '0';
      this.capsules_status = '2';
    }
    else if (event.index == 2) { // draft
      this.is_active = '1';
      this.capsules_status = '1';
    } else {
      this.is_active = '1';
      this.capsules_status = '2'; //active
    }
    
    this.getContentAuthList(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order);
  }
  getContentAuthList(searchText: any, is_active: any, capsules_status: any = this.capsules_status, order_by: any = this.order_by, order: any = this.order) {
    this.spinner.show();
    this.contentAuthoringApi.getContentAuthList(searchText, is_active, capsules_status, order_by, order).subscribe(
      (data) => {
        console.log(data);
        if (data.success) {
          this.spinner.hide();
          console.log(data);
          this.contentAuthData = data.contentCapsules;
          //console.log(data.contentCapsules);
          //this.router.navigateByUrl('/assigned'); 
        } else {

          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  getContentAuthLists(searchText: any, is_active: any, capsules_status: any = this.capsules_status, order_by: any = this.order_by, order: any = this.order) {
    //this.spinner.show();
    this.contentAuthoringApi.getContentAuthList(searchText, is_active, capsules_status, order_by, order).subscribe(
      (data) => {
        //console.log(data);
        if (data.success) {
         // this.spinner.hide();
          //console.log(data);
          this.contentAuthData = data.contentCapsules;
          //console.log(data.contentCapsules);
          //this.router.navigateByUrl('/assigned'); 
        } else {

          //this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  getMediaType(mediatypeArr: any, media_type: any) {
    const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
    return mediatypeArr.some(checkMediType);
  }
  // authringDetails(content_capsule_id: any) {
  //   // alert(content_capsule_id);
  //   this.router.navigate(['/authoring_view'], { queryParams: { 'id': content_capsule_id } });
  // }
  searchold(value: string): void {
    this.contentAuthData = this.contentAuthData.filter((val: { capsule_name: string; }) => val.capsule_name.toLowerCase().includes(value));
  }
  search(event: any) {
    this.searchText = event.target.value;
    this.getContentAuthLists(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order);
  }

  /***** Shorting listing by capsule name****/
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = sort.direction;
    } else { this.order_by = 'created_dttm'; this.order = 'DESC'; }
    this.getContentAuthList(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order);
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(capsule_id: any, is_actives: any) {
    this.changeIsActiveVal(capsule_id, is_actives);
  }
  /*******create duplicate content capsule  *****/
  duplicateCapsule(capsule_id: any,tab_name:any) {
    this.spinner.show();
    this.contentAuthoringApi.getContentAuthDetails(capsule_id).subscribe(
      (data) => {
        if (data.status == 200) {
          this.contentDetailsData = data.data;
          this.contentDetailsData['capsule_name'] = this.contentDetailsData.capsule_name + '-copy';
          this.contentDetailsData['capsules_status'] = 1;
          delete this.contentDetailsData['content_capsule_id'];
          this.contentDetailsData['created_by']='1';
          delete this.contentDetailsData['created_dttm'];
          if(tab_name =='Deactivated'){
            this.contentDetailsData['is_active'] = 0;
          }
           let arr = this.contentDetailsData.contentCapsuleMedia;
           for (let n = 0; n < arr.length; n++) {
            if(arr[n]['media_type'] === 2 ){
              this.toDataURL(arr[n]['media_path'], function (dataURL: any) {
                arr[n]['media_path'] = dataURL;
              });
           } 
           if(arr[n]['media_type'] === 3 ){
            this.toDataURL(arr[n]['media_path'], function (dataURL: any) {
              arr[n]['media_path'] = dataURL;
            });
          }
            delete arr[n]['content_capsule_id'];
            delete arr[n]['created_by'];
            delete arr[n]['created_dttm'];
            delete arr[n]['content_capsule_media_id'];
            delete arr[n]['modified_dttm'];
            delete arr[n]['sort_order'];
            delete arr[n]['is_active'];
           }
          setTimeout(() => {
          this.saveDuplicateCapsule(this.contentDetailsData);
          }, 10000);
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  /************duplicate create content authoring (capsule) *******/
  saveDuplicateCapsule(contentAuthForm: any) {
   // alert("hello");
   // console.log(contentAuthForm);return false;
    this.contentAuthoringApi.upload(contentAuthForm,'create').subscribe(
      (data) => {
        if (data.status == 201 || data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getContentAuthList(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order);
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Something went wrong.'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );

  }
  /*******delete content capsule  *****/
  deleteCapsule(capsule_id: any) {
    this.contentAuthoringApi.deletesCapsule(capsule_id).subscribe(
      (data) => {
        //console.log(data);
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getContentAuthList(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order);
          //this.router.navigate(['/authoring_list']);
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }

  changeIsActiveVal(content_capsule_id: any, is_active: any) {
    this.contentAuthoringApi.changeIsActiveVal(content_capsule_id, is_active).subscribe(
      (data) => {
       // console.log(data);
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getContentAuthList(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order);
          this.router.navigate(['/authoring_list']);
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  publishCapsule(content_capsule_id:any){
    this.contentAuthoringApi.publishCapsule(content_capsule_id).subscribe(
      (data) => {
       // console.log(data);
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getContentAuthList(this.searchText, this.is_active, this.capsules_status, this.order_by, this.order);
          this.router.navigate(['/authoring_list']);
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }
}




